import UserDatabase from "pages/Admin/UserDatabase";

export default function UserDatabasePage() {
  return <UserDatabase />;
}
